import { css } from 'emotion';
import { colors, fonts } from '@peachjar/components';

const { silver, prussian, platinum, mercury, gold, jungle } = colors;
const { ProximaNova } = fonts;

export const styles = {
  container: css`
    background-color: white;
  `,
  button: css`
    font-family: ${ProximaNova};
  `,
  instructionsButton: css`
    width: 147px;
    height: 32px;
    margin-left: 0;
    margin-top: 0;
    margin-bottom 32px;
  `,
  downloadButton: css`
    width: 186px;
    height: 32px;
    margin-left: 0;
  `,
  uploadButton: css`
    width: 203px;
    cursor: pointer;
  `,
  continueButton: css`
    margin-right: 0;
  `,
  tableWrapper: css`
    padding: 4rem 5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  `,
  lineItem: css`
    font-size: 13px;
    font-family: ${ProximaNova};
    width: 24px;
    height: 24px;
    border: solid 2px ${gold};
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  headline2: css`
    font-family: ${ProximaNova};
    font-size: 25px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.28;
    letter-spacing: normal;
    color: ${prussian};
    margin-bottom: 4px;
  `,
  fileUploadButton: css`
    position: absolute;
    cursor: pointer;
    top: 0;
    right: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
  `,
  fileUploadWrapper: css`
    width: 920px;
    background-color: #fafafa;
    border: 2px dashed ${silver};
    border-radius: 6px;
  `,
  fileUploadButtonWrapper: css`
    position: relative;
    height: 64px;
    width: 203px;
    margin-top: 24px;
    overflow: hidden;
  `,
  fileUploadMessage: css`
    color: ${prussian};
    font-size: 16px;
    font-weight: bold;
  `,
  tableContinueButtonWrapper: css`
    display: flex;
    align-items: center;
    margin-top: 1.5rem;
  `,
  tableContinueBackButton: css`
    margin-right: 58px;
    cursor: pointer;
    color: ${jungle};
  `,
  uploadWrapper: css`
    background-color: white;
    padding: 4rem;
    border-radius: 3px;
  `,
  readOnlyWrapper: css`
    padding: 4rem 5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  `,
  readOnlyContinueButtonWrapper: css`
    display: flex;
    align-items: center;
    margin-top: 1.5rem;
    maring-right: 1rem;
  `,
};



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/staff/containers/UploadStaffTab.css.js